import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtrovert = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Extrovert Icon",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M23.999 24.9587L24.0003 25C24.0003 25.3 23.9843 25.596 23.951 25.888",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M24.0003 24.96C23.9951 23.4488 23.5599 21.969 22.7456 20.696C22.0228 19.5624 21.0258 18.6294 19.8467 17.9833C18.6677 17.3373 17.3447 16.9991 16.0003 17C14.6561 16.9993 13.3334 17.3376 12.1546 17.9837C10.9758 18.6297 9.97898 19.5626 9.25631 20.696C8.44247 21.9692 8.0051 23.4476 8.00031 24.9587M9.25631 20.696C8.63259 20.2705 7.90116 20.0301 7.1466 20.0028C6.39203 19.9755 5.64515 20.1624 4.99231 20.5417C4.33946 20.9211 3.80732 21.4774 3.45741 22.1465C3.1075 22.8156 2.95411 23.5701 3.01497 24.3227M20.0003 9C20.0003 10.0609 19.5789 11.0783 18.8287 11.8284C18.0786 12.5786 17.0612 13 16.0003 13C14.9394 13 13.922 12.5786 13.1719 11.8284C12.4217 11.0783 12.0003 10.0609 12.0003 9C12.0003 7.93913 12.4217 6.92172 13.1719 6.17157C13.922 5.42143 14.9394 5 16.0003 5C17.0612 5 18.0786 5.42143 18.8287 6.17157C19.5789 6.92172 20.0003 7.93913 20.0003 9ZM25.0003 10C25.796 10 26.559 10.3161 27.1216 10.8787C27.6842 11.4413 28.0003 12.2044 28.0003 13C28.0003 13.394 27.9227 13.7841 27.7719 14.1481C27.6212 14.512 27.4002 14.8427 27.1216 15.1213C26.8431 15.3999 26.5123 15.6209 26.1484 15.7716C25.7844 15.9224 25.3943 16 25.0003 16C24.6063 16 24.2162 15.9224 23.8523 15.7716C23.4883 15.6209 23.1576 15.3999 22.879 15.1213C22.6004 14.8427 22.3794 14.512 22.2287 14.1481C22.0779 13.7841 22.0003 13.394 22.0003 13C22.0003 12.2044 22.3164 11.4413 22.879 10.8787C23.4416 10.3161 24.2047 10 25.0003 10ZM9.12163 15.1213C8.84305 15.3999 8.51233 15.6209 8.14836 15.7716C7.78438 15.9224 7.39427 16 7.00031 16C6.60634 16 6.21623 15.9224 5.85226 15.7716C5.48828 15.6209 5.15756 15.3999 4.87899 15.1213C4.60041 14.8427 4.37943 14.512 4.22867 14.1481C4.0779 13.7841 4.00031 13.394 4.00031 13C4.00031 12.2044 4.31638 11.4413 4.87899 10.8787C5.44159 10.3161 6.20466 10 7.00031 10C7.79596 10 8.55902 10.3161 9.12163 10.8787C9.68424 11.4413 10.0003 12.2044 10.0003 13C10.0003 13.394 9.92271 13.7841 9.77194 14.1481C9.62118 14.512 9.4002 14.8427 9.12163 15.1213Z",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M28.9883 24.3213C29.0494 23.5685 28.8961 22.8138 28.5461 22.1445C28.1961 21.4752 27.6638 20.9186 27.0107 20.5392C26.3577 20.1598 25.6105 19.9731 24.8557 20.0006C24.1009 20.0281 23.3694 20.2687 22.7456 20.6947",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M8.04964 25.888C8.01536 25.5794 7.99889 25.2691 8.00031 24.9587",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgExtrovert;
